import { useQuery } from 'react-query';
import StockExChangeService from '~/api/services/stockExchange';
import { onError } from '~/utils/helpers';

const getMilkFixexPriceList = (data?) => useQuery(
  `stock-exchange-price-list-${data.search}`,
  () => StockExChangeService.getMilkFixedPriceIndex(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceListOptions = () => useQuery(
  'stock-exchange-price-list-options',
  StockExChangeService.getMilkFixedPriceIndexData,
  {
    onError,
    refetchOnMount: false,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOptions = () => useQuery(
  'stock-exchange-price-options',
  StockExChangeService.getMilkFixedPriceOptions,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceCount = (data?) => useQuery(
  `stock-exchange-price-count-${data.search}`,
  () => StockExChangeService.countTradingSlots(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffers = (id, data?) => useQuery(
  'stock-exchange-price-offers',
  () => StockExChangeService.offersPreviewTradingSlot(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffersByOptions = (id, farmerId?) => useQuery(
  'stock-exchange-price-offers-list',
  () => StockExChangeService.offersPreviewTradingSlotByMonths(id, farmerId),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffersData = (id, farmerGroupId, data?) => useQuery(
  'stock-exchange-price-offers-data',
  () => StockExChangeService.getOffersData(id, farmerGroupId, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffersSettings = (id) => useQuery(
  'stock-exchange-price-offers-settings',
  () => StockExChangeService.offersPreviewTradingSlotOptions(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getTradingActivities = (data?) => useQuery(
  'stock-exchange-price-trading-activities',
  () => StockExChangeService.getTradingActivities(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const getTradingActivityOptions = () => useQuery(
  'stock-exchange-price-activity-options',
  () => StockExChangeService.offersStatusOptions(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerSettingsMilk = () => useQuery(
  'stock-exchange-price-farmer-trading-options',
  () => StockExChangeService.getTradingSlotsFarmerSettings(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getStonexContracts = (data?) => useQuery(
  'stone-x-blue-contracts',
  () => StockExChangeService.getStoneXContracts(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getStonexContractsOptions = (data?) => useQuery(
  'stone-x-blue-contracts-options',
  () => StockExChangeService.getStoneXContractsOptions(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const StockExchangeQuery = {
  getMilkFixexPriceList,
  getMilkFixexPriceListOptions,
  getMilkFixexPriceOptions,
  getMilkFixexPriceCount,
  getMilkFixexPriceOffers,
  getMilkFixexPriceOffersByOptions,
  getMilkFixexPriceOffersSettings,
  getTradingActivities,
  getTradingActivityOptions,
  getFarmerSettingsMilk,
  getMilkFixexPriceOffersData,
  getStonexContracts,
  getStonexContractsOptions
}

